<div class="media-thumbnail" (click)="onOpenInNewTab($event)" title="Open in new tab">
  @if (isVideo) {
    <video class="thumbnail-img" [src]="thumbnailUrl" muted playsinline preload="metadata"></video>
    <div class="play-overlay">
      <div class="play-icon"></div>
    </div>
  } @else {
    <img class="thumbnail-img" [src]="thumbnailUrl" [alt]="altText"/>
  }
</div>
